export enum MessageType {
  Info, Warn, Error, Succ
}
